var nb = require('../nb');
module.exports = nb.define({
    view: {
        'class': ['btn', nb.bind('btnSize'), nb.bind('btnColor'), nb.bind('loading'), nb.bind('status')],
        'data-trace-event': nb.bind('traceEvent'),
        'data-trace-action': nb.bind('traceAction'),
        tag: 'button',
        disabled: nb.bind('disabled'),  //disabled 属性规定禁用按钮。被禁用的按钮既不可用，也不可点击。
        $text: nb.bind('text')
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/Button.js
// module id = 59
// module chunks = 0 2 4 5 6 13 32 35